// Módulo para interacciones con la API de Ines
class InesAPI {
  constructor() {
    this.baseUrl = 'https://ssttbeca.ines.cl/ssttbeca';
  }

  // Consultar orden existente
  async consultarOrden(orderNumber) {
    const formData = new FormData();
    formData.append('ot', orderNumber);
    
    const response = await fetch(`${this.baseUrl}/consulta.php`, {
      method: 'POST',
      body: formData
    });
    
    const text = await response.text();
    return this.parseResponse(text);
  }

  // Crear nueva orden
  async crearOrden(orderData) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(orderData));
    formData.append('email', orderData.email);
    formData.append('productImage', orderData.productImage || '');
    formData.append('boletaImage', orderData.boletaImage || '');
    
    const response = await fetch(`${this.baseUrl}/registro.php`, {
      method: 'POST',
      body: formData
    });
    
    const text = await response.text();
    return this.extractOrderInfo(text);
  }

  // Actualizar estado de orden
  async actualizarEstado(ordenId, estado) {
    const updateData = {
      orden_id: ordenId,
      estado: estado
    };

    const response = await fetch(`${this.baseUrl}/update.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updateData)
    });
    
    return response.text();
  }

  // Parsear respuesta de consulta
  parseResponse(text) {
    try {
      return JSON.parse(text);
    } catch (jsonError) {
      // Intentar limpiar y parsear
      try {
        const cleaned = text.replace(/\\n/g, "\\n")
          .replace(/\\'/g, "\\'")
          .replace(/\\"/g, '\\"')
          .replace(/\\&/g, "\\&")
          .replace(/\\r/g, "\\r")
          .replace(/\\t/g, "\\t")
          .replace(/\\b/g, "\\b")
          .replace(/\\f/g, "\\f")
          .replace(/[\u0000-\u0019]+/g, "");
        return JSON.parse(cleaned);
      } catch (error) {
        throw new Error('La respuesta del servidor no pudo ser procesada');
      }
    }
  }

  // Extraer información de orden de la respuesta
  extractOrderInfo(text) {
    let ordenId = "GENERADO";
    let pdfUrl = "";
    
    // Buscar URL del PDF
    const urlPdfMatch = text.match(/https?:\/\/[^"\s]+pdfProducto\.php\?ticket=[0-9]+/);
    if (urlPdfMatch) {
      pdfUrl = urlPdfMatch[0].replace(/\\\//g, '/');
    }
    
    // Buscar código BECA
    const cobaMatch = text.match(/COBATFDV([0-9]+)/i);
    if (cobaMatch) {
      ordenId = "COBATFDV" + cobaMatch[1];
      return { ordenId, pdfUrl };
    }
    
    // Otros patrones de búsqueda
    const patronesBusqueda = [
      /[Cc][Óóo][Dd][Ii][Gg][Oo](?:\s+)[Bb][Ee][Cc][Aa][:=\s]+([A-Za-z0-9]+)/i,
      /orden\s+(?:número\s+)?([0-9A-Za-z]+)/i,
      /generada.*?([A-Z0-9]{6,})/i,
      /id[=:]\s*['"]?([0-9A-Za-z]+)['"]?/i
    ];
    
    for (const patron of patronesBusqueda) {
      const coincidencia = text.match(patron);
      if (coincidencia && coincidencia[1]) {
        ordenId = coincidencia[1];
        break;
      }
    }
    
    return { ordenId, pdfUrl };
  }
}

// Instancia global
window.inesAPI = new InesAPI();